import controller from './no-auth.controller';

export default {
  controller,
  template: require('./no-auth.html')
};



// WEBPACK FOOTER //
// src/app/no-auth/no-auth.component.ts